__turbopack_context__.v({
  "description": "list-item-module__NItl6G__description",
  "icon": "list-item-module__NItl6G__icon",
  "row": "list-item-module__NItl6G__row",
  "rowInteractive": "list-item-module__NItl6G__rowInteractive",
  "textGroup": "list-item-module__NItl6G__textGroup",
  "title": "list-item-module__NItl6G__title",
  "trailing": "list-item-module__NItl6G__trailing",
});
